import React from 'react'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { useNotify } from 'ra-core'
import { IconButtonWithTooltip } from 'react-admin'

type Props = {
  text: string
  label: string
  notificationLabel: string
}

const CopyToClipboard: React.FC<Props> = ({
  text,
  label,
  notificationLabel,
}) => {
  const notify = useNotify()

  const handleClick = () => {
    navigator.clipboard.writeText(text)
    notify(notificationLabel, { type: 'info' })
  }

  return (
    <IconButtonWithTooltip onClick={handleClick} color="primary" label={label}>
      <ContentCopyIcon />
    </IconButtonWithTooltip>
  )
}

export default CopyToClipboard
